import { Spin } from 'antd';
// tslint:disable-next-line: no-submodule-imports
import 'antd/dist/antd.css';
// tslint:disable-next-line: no-submodule-imports
import 'antd/dist/antd.variable.min.css';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';
import './App.css';
import './i18n/config';
import LoginComponent from './Pages/Authentication/Components/Login';
import SignupComponent from './Pages/Authentication/Components/SignUp';
import HomePage from './Pages/HomePage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Redirection from './Pages/Redirection';
import Response from './Pages/Redirection/response';
import Root from './Pages/Root';
import TermsAndCondition from './Pages/TermsAndCondition';
import { Routes } from './Utils/Constants/routes';
import interceptor from './Utils/interceptor';

function App() {
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );

  const history = useHistory();

  useState(() => {
    interceptor(history);
  });
  return (
    <Spin
      spinning={loading}
      wrapperClassName={
        history.location.pathname.includes(Routes.terms) ||
        history.location.pathname.includes(Routes.privacy)
          ? 'termsAndPrivacy'
          : ''
      }
    >
      <Switch>
        <Route exact={true} path={Routes.terms} component={TermsAndCondition} />
        <Route exact={true} path={Routes.privacy} component={PrivacyPolicy} />
        <Route exact={true} path={Routes.home} component={HomePage} />
        <Route exact={true} path={Routes.login} component={LoginComponent} />
        <Route exact={true} path={Routes.signup} component={SignupComponent} />
        <Route exact={true} path={Routes.webview} component={Redirection} />
        <Route exact={true} path={Routes.redirected} component={Response} />
        <Route exact={true} path='*' component={Root} />
      </Switch>
    </Spin>
  );
}
export default App;
